import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import FriendlyCompanyHandler from './FriendlyCompanyHandler';

function FriendlyCompany(): React.ReactElement {
    return (
        <Switch>
            <Route strict path="/company/:friendlyName">
                <FriendlyCompanyHandler />
            </Route>
            <Redirect exact from="/company" to="/" />
        </Switch>
    );
}

export default FriendlyCompany;
